/* src/@partials/layout/topbar/user-profile/user-profile.component.scss */
/*# sourceMappingURL=user-profile.component-5ZTZHRGA.css.map */
